import React, { useState, useContext } from 'react';
import SendEmailBlock from '~/components/SendEmailBlock';
import {
  ActivityFieldsFragment,
  TaskStatus,
  useUpdateTaskMutation,
} from '~/graphql/types';
import useCurrentAccount from '~/hooks/useCurrentAccount';
import { TaskUpdaterContext } from '~/scenes/Tasks/components/TaskList/TaskUpdaterContext';
import TaskModalContext from '~/scenes/Tasks/components/TaskModal/TaskModalContext';
import { ActivityTabProps } from '../..';

export type SendMessageTabContact = {
  name: string;
  email: string;
  id: string;
};

type Props = ActivityTabProps & {
  handleCloseModal?: () => void;
  contact: SendMessageTabContact;

  /** Called when sending was a success and all other sideeffects are handled */
  onSuccess: (newEmailActivity: ActivityFieldsFragment) => void;
};

const SendMessageTab: React.FC<Props> = ({ contact, handleCloseModal }) => {
  const account = useCurrentAccount();
  const { taskDetails } = useContext(TaskModalContext);
  const { onTaskChanged } = useContext(TaskUpdaterContext);
  const [hasError, setHasError] = useState<boolean>(false);
  const [allowUpdateStatus, setAllowUpdateStatus] = useState<boolean>(false);
  const [allowClose, setAllowClose] = useState<boolean>(false);

  const [updateTask, { loading }] = useUpdateTaskMutation();

  const setAfterSendActions = ({
    allowUpdateStatus,
    allowClose,
  }: {
    allowUpdateStatus: boolean;
    allowClose: boolean;
  }) => {
    setAllowClose(allowClose);
    setAllowUpdateStatus(allowUpdateStatus);
  };

  const onTaskUpdate = () => {
    if (allowUpdateStatus) {
      if (taskDetails) {
        const newStatus =
          taskDetails.status === TaskStatus.Open
            ? TaskStatus.Closed
            : TaskStatus.Open;
        void updateTask({
          variables: {
            accountId: account.id,
            id: taskDetails.id,
            update: {
              status: newStatus,
            },
          },
        }).then(({ data, errors }) => {
          if (errors && errors.length > 0) {
            return setHasError(true);
          }

          if (data) {
            if (allowClose && typeof handleCloseModal === 'function') {
              handleCloseModal();
            }
            setHasError(false);
            onTaskChanged(data.updateTask);
            return;
          }

          return;
        });
      }
    } else if (!allowUpdateStatus && allowClose && handleCloseModal != null) {
      handleCloseModal();
    }
  };

  return (
    <SendEmailBlock
      handleCloseModal={handleCloseModal}
      receiver={{
        email: contact.email,
        name: contact.name,
      }}
      onHeightChange={() => {}}
      loading={loading}
      error={hasError}
      setAfterSendActions={setAfterSendActions}
      onSuccess={onTaskUpdate}
      contactId={contact.id}
    />
  );
};

SendMessageTab.defaultProps = {
  label: 'Verstuur e-mail',
  datatestId: 'send-message',
};

export default SendMessageTab;
